define([
    "./hereMapsModule"
], function(hereMapsModule) {
    "use strict";

    return hereMapsModule.service("hereMapsViewportService", [
        "hereMapsService",
        function (hereMapsService) {


            return {
                centerMapOnBoundingBoxWithPadding: centerMapOnBoundingBoxWithPadding
            };

            function centerMapOnBoundingBoxWithPadding(boundingBox, padding){
                if (!boundingBox) {
                    return;
                }
                var map = hereMapsService.getMap();

                map.getViewPort().setPadding(padding, padding, padding, padding);

                map.getViewModel().setLookAtData({
                    bounds: boundingBox,
                });

            }
        }

    ]);
});